// extracted by mini-css-extract-plugin
export var button = "_fg-4";
export var hasDarkBackground = "_fg-7";
export var hasLightBackground = "_fg-6";
export var iconWrapper = "_fg-0";
export var large = "_fg-2";
export var medium = "_fg-1";
export var small = "_fg-5";
export var xsmall = "_fg-3";